// mon-fri, 12pm-1am of the next day UTC
export const isWithinSupportHours = (): boolean => {
  const now = new Date();
  const hour = now.getUTCHours();
  const day = now.getUTCDay();

  return (
    (day === 1 && hour >= 12) ||
    (day >= 2 && day <= 5 && (hour >= 12 || hour < 1)) ||
    (day === 6 && hour < 1)
  );
};
